import createClient from "openapi-fetch";

import { type paths } from "./__generated__/schema";
import { authMiddleware, errorMiddleware } from "./middlewares.ts";
import {
  type AvailableTypes,
  AVAILABLE_TYPES,
  DEFAULT_TYPE,
  type DefaultType,
} from "./types.ts";

export const createApiClient = <T extends keyof AvailableTypes = DefaultType>(
  type = DEFAULT_TYPE as T,
) => {
  const apiClient = createClient<paths, AvailableTypes[T]>({
    baseUrl: import.meta.env.VITE_API_URL,
    headers: {
      Accept: AVAILABLE_TYPES[type],
    },
  });

  apiClient.use(authMiddleware, errorMiddleware);

  return apiClient;
};
